export function makeDateStampObject(year, month, day) {
    return {
        year,
        month,
        day
    };
}
export function makeDateStampArray(year, month, day) {
    return [
        year,
        month,
        day
    ];
}
